"use strict";

(function ($) {
  $.fn.lawyerClubs = function () {
    var that = $(this);

    if (that.length >= 3) {
      $('.js-add-club').hide();
    } else {
      $('.js-add-club').show();
    }

    that.each(function () {
      var lawyerClub = $(this).prev().val();
      $(this).on('change', function () {
        $(this).next().attr('data-id', $(this).val());
      });
      $(this).next().attr('data-id', $(this).val());
      $(this).find('option').each(function () {
        if ($(this).val() == lawyerClub) {
          var value = $(this).text();
          var id = $(this).val();
          $(this).parent().next().text(value);
          $(this).parent().next().attr('data-id', id);
        }
      });
    });
  };
})(jQuery);